var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.titulo))]),_c('v-spacer'),_c('v-icon',{on:{"click":_vm.close}},[_vm._v("mdi-close")])],1),_c('v-form',{ref:"form"},[_c('v-container',[_c('v-row',[(_vm.justificativaRecusa)?_c('TextAreaField',{attrs:{"disabled":true,"rules":[],"title":"Justificativa da Recusa Férias","id":"justificativa-recusa","vModel":_vm.justificativaRecusa,"responsive":{
            lg: 3,
            md: 3,
            sm: 12,
            cols: 12,
          }}}):_vm._e(),_c('PeriodoField',{attrs:{"disabled":true,"title":"Período de Férias Solicitados","id":"periodo","vModelFirst":_vm.form.dataInicio,"vModelLast":_vm.form.dataFim}}),_c('TextField',{attrs:{"disabled":true,"rules":[
            (v) => !!v || 'Campo obrigatório não informado.',
            (v) => !!(v > 0) || 'O número de dias deve ser maior que zero',
            ,
            (v) =>
              !!(v <= _vm.limiteDias) ||
              `O número de dias deve ser menor que ${_vm.limiteDias}`,
          ],"title":_vm.numeroDiasTitulo,"id":"numero-dias-cassados","type":"number","vModel":_vm.form.numeroDias,"responsive":{
            lg: 3,
            md: 3,
            sm: 12,
            cols: 12,
          }}}),_c('PeriodoField',{attrs:{"disabledTwo":true,"title":"Período de Cassação das Férias","id":"periodo","vModelFirst":_vm.form.dataCassacaoInicio,"vModelLast":_vm.form.dataCassacaoFim,"rulesFirst":[
            (v) => !!v || 'Campo obrigatório não informado.',
            (v) =>
              v >= _vm.form.dataInicio ||
              'A data informada está fora do período de férias solicitada.',
          ],"rulesLast":[
            (v) => !!v || 'Campo obrigatório não informado.',
            (v) =>
              v <= _vm.form.dataFim ||
              'A data informada está fora do período de férias solicitada.',
          ]},on:{"inputFirst":function($event){_vm.form.dataCassacaoInicio = $event},"inputLast":function($event){_vm.form.dataCassacaoFim = $event}}}),_c('TextField',{attrs:{"rules":[
            (v) => !!v || 'Campo obrigatório não informado.',
            (v) => !!(v > 0) || 'O número de dias deve ser maior que zero',
            ,
            (v) =>
              !!(v <= _vm.form.numeroDias) ||
              'O número de dias deve ser menor que o total de dias solicitados',
          ],"title":_vm.numeroDiasTitulo,"id":"numero-dias-cassados","type":"number","vModel":_vm.form.diasCassacao,"responsive":{
            lg: 3,
            md: 3,
            sm: 12,
            cols: 12,
          }},on:{"input":function($event){_vm.form.diasCassacao = $event},"on-blur":function($event){return _vm.calculateDays()}}}),_c('v-container',{attrs:{"fluid":""}},[_c('v-textarea',{attrs:{"rules":[(v) => !!v || 'Campo obrigatório não informado.'],"counter":"","label":"Informe a Justificativa de Cassação das férias","value":_vm.value},model:{value:(_vm.form.justificativa),callback:function ($$v) {_vm.$set(_vm.form, "justificativa", $$v)},expression:"form.justificativa"}})],1)],1)],1)],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.prepareForm()}}},[_vm._v(" Enviar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }